import { render, staticRenderFns } from "./Licenses-Deployed.vue?vue&type=template&id=1bbb8c87&scoped=true&"
import script from "./Licenses-Deployed.vue?vue&type=script&lang=js&"
export * from "./Licenses-Deployed.vue?vue&type=script&lang=js&"
import style0 from "./Licenses-Deployed.vue?vue&type=style&index=0&id=1bbb8c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbb8c87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VIcon,VProgressCircular,VRow})
